import api from './index'
import { axios } from '@/utils/request'

export function restoreStatus(parameter) {
  return axios({
    url: api.BaseURL + api.Mobile + 'restore_status',
    method: 'GET',
    params: parameter
  })
}